<template>
  <generic-modal :title="$t('report')" ref="generic_modal">
    <div>
      <div class="title is-4" v-if="meta.project && meta.project.name">
        {{ meta.project.name }}
        <small>| {{ meta.project.settings.customer }}</small>
      </div>

      <!-- <pre>{{ meta.project }}</pre> -->
    </div>
    <div>
      <p>{{ module_settings.report_text }}</p>
    </div>
    <div class="grid is-col-min-7">
      <div class="cell" v-for="(photo, midx) in meta.photos" :key="midx">
        <div class="card">
          <div class="card-image">
            <figure class="image is-128x128 m-auto py-3">
              <v-lazy-image :src="`${api_host}/drive/static/${photo.file}`" />
            </figure>
          </div>
          <div class="card-content">
            <div class="media">
              <div class="media-content">
                <!-- <p class="subtitle is-7 has-text-centered">
                  {{ photo.file }}
                </p> -->
                <p class="subtitle is-7 has-text-centered">
                  {{ photo.description }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button class="button is-primary is-rounded" @click="generate_pdf">
        <span class="icon">
          <i class="fa fa-file-pdf-o"></i>
        </span>
        <span>{{ $t("generate pdf") }}</span>
      </button>
      <button class="button is-secondary is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("close") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  api_host,
  error_message,
  get,
  del,
  post,
  error_alert,
  input_alert,
  generate_error_message_text,
  confirm_deletion_dialog,
  get_currency_settings,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import VLazyImage from "v-lazy-image";

export default {
  name: "ReportModal",
  components: { GenericModal, VLazyImage },
  props: { module_settings: Object },
  data() {
    return {
      api_host: api_host,
      meta: {},
      error: "",
      uuid: "",
    };
  },
  computed: {},
  methods: {
    get_currency_settings,
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal(project_uuid) {
      // console.log("show_modal", project_uuid);
      let v = this;
      v.set_initial_state();

      if (project_uuid) {
        v.uuid = project_uuid;
        v.init();
        v.$refs.generic_modal.show_modal();
      } else v.$refs.generic_modal.show_modal();
    },
    init() {
      let v = this;
      get("/air_project/photo/all", { uuid: v.uuid })
        .then((rspnse) => {
          v.meta.photos = rspnse.photos;
          v.meta.project = rspnse.project;
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        name: "",
        settings: {},
      };
      v.error = "";
      v.uuid = "";
    },
    error_uploading(error) {
      let v = this;
      v.error = generate_error_message_text(error);
    },
    success_uploading(response) {
      let v = this;
      v.$refs.generic_uploader.clear();
      v.init();
    },
    remove(photo) {
      let v = this;
      confirm_deletion_dialog(v.$t("are you sure to delete photo?"), v, () => {
        del("/air_project/photo", { uuid: photo.uuid })
          .then(() => {
            v.init();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      });
    },
    describe(photo) {
      let v = this;
      let options = {
        input: "textarea",
        title: v.$t("describe photo"),
        input_value: photo.description,
        placeholder: v.$t("description"),
        confirm_text: v.$t("save"),
        cancel_text: v.$t("cancel"),
      };
      input_alert(options).then((value) => {
        post("/air_project/photo/description", {
          uuid: photo.uuid,
          description: value,
        })
          .then(() => {
            v.init();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      });
    },
    generate_pdf() {
      let v = this;
      get("/air_project/report/pdf", { uuid: v.uuid })
        .then((rspnse) => {
          let url = `${api_host}/drive/static/${rspnse.file}`;
          window.open(url, "_blank");
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
  },
  mounted() {},
  watch: {},
};
</script>

<style scoped>
/* .grid .cell .card:hover {
  border-radius: 0.5em;
  box-shadow: 0px 0px 5px 1px rgba(0, 209, 178, 0.9);
  transition: linear 0.1s;
  transform: scale(1.05, 1.05);
} */
</style>
